import React, { useState } from "react";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import EducationProcessFlow from "./EducationProcessFlow";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";
import {
  EDUCATION_DOMAIN_INTRO,
  EDUCATION_GROUPS,
  EDUCATION_USE_CASES_SEO,
  EDUCATION_DOMAIN_FAQS,
  EDUCATION_ITEM_LIST_JSONLD,
  EDUCATION_BREADCRUMB_JSONLD,
  EDUCATION_WEBPAGE_JSONLD,
  EDUCATION_FAQ_JSONLD,
} from "../../data/educationUseCases";


function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<EducationProcessFlow useCaseId={useCase.id} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = EDUCATION_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">{cases.map((uc) => <UseCaseCard key={uc.id} useCase={uc} />)}</div>
    </section>
  );
}

export default function EducationDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups = activeFilter === "all" ? EDUCATION_GROUPS : EDUCATION_GROUPS.filter((g) => g.id === activeFilter);
  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={EDUCATION_DOMAIN_INTRO}
        domainSlug="education-domain"
        useCaseCount={EDUCATION_USE_CASES_SEO.length}
        groupCount={EDUCATION_GROUPS.length}
        itemListJsonLd={EDUCATION_ITEM_LIST_JSONLD}
        breadcrumbJsonLd={EDUCATION_BREADCRUMB_JSONLD}
        faqJsonLd={EDUCATION_FAQ_JSONLD}
        webPageJsonLd={EDUCATION_WEBPAGE_JSONLD}
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{EDUCATION_DOMAIN_INTRO.title}</h1>
          {EDUCATION_DOMAIN_INTRO.content ? <p>{EDUCATION_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid useCases={EDUCATION_USE_CASES_SEO} groups={EDUCATION_GROUPS} heading="Education Use Cases" onFilterChange={setActiveFilter} />
      <div className="fin-wrap">{visibleGroups.map((group) => <GroupSection key={group.id} group={group} />)}</div>
      <DomainHiddenSeoContent
        domainTitle={EDUCATION_DOMAIN_INTRO.title}
        domainFaqs={EDUCATION_DOMAIN_FAQS}
        useCases={EDUCATION_USE_CASES_SEO}
      />
    </div>
  );
}

